import React, { useEffect, useState } from "react";
import { setKey, setStringifiedKey } from "../store/actions";
import { connect } from "react-redux";
import utils from '../utils/utils'
import PurchaseItemRow from "./PurchaseItemRow";
import paymentService from "../services/payment";

function PurchaseItem({ session, setKey, ...props }) {

	const k = props.data;

	return (
		<>
			<div className="box mb-20" style={{border: '1px solid #000'}}>
				<div className="row">
					<div className="col-8">
						<span className="cart-title mr-30">Order # {props.idx} | Shopping Basket</span>
						<hr />
						<table className="cart-items table table-responsive table-borderless">
							<thead>
								<tr>
									<th colSpan={2} className="text-center">Item</th>
									<th>Item Price</th>
									<th>Quantity</th>
									<th className="text-end">Total Price</th>
								</tr>
							</thead>
							<tbody>
								{k.cart.map(g => <PurchaseItemRow data={g} key={g.id} />)}
							</tbody>
						</table>
					</div>
					<div className="col-4">
						<p className="cart-title">Order Summary</p>
						<hr />
						<table className="w-100">
							<tbody>
								<tr>
									<td>Sub Total</td>
									<td className="text-end">{utils.formatToCurrency(k.amount, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</td>
								</tr>
								<tr>
									<td>Shipping</td>
									<td className="text-end">{utils.formatToCurrency(0, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</td>
								</tr>
								<tr>
									<td className="td-strong">Total</td>
									<td className="text-end td-strong">{utils.formatToCurrency(k.amount, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</td>
								</tr>
								<tr>
									<td className="">Date</td>
									<td className="text-end">{utils.dayMonthYearFormat(k.date)}</td>
								</tr>
								{
									k.status === "cancelled" &&
									<tr>
										<td className="td-strong">Date Cancelled</td>
										<td className="text-end td-strong">{utils.dayMonthYearFormat(k.dateCancelled)}</td>
									</tr>
								}
								<tr>
									<td className="td-strong">Delivery address</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td className="text-end">
									<span>{k.deliveryAddress.firstname} {k.deliveryAddress.lastname}</span><br/>
									<span>{k.deliveryAddress.lane1}</span><br/>
									<span>{k.deliveryAddress.lane2}</span><br/>
									<span>{k.deliveryAddress.postcode}</span><br/>
									<span>{k.deliveryAddress.city}</span><br/>
									<span>{k.deliveryAddress.countryId.title}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseItem);
